export {default as Example} from './modules/Example';
export {default as Load} from './modules/Load';
export {default as Scroll} from './modules/Scroll';
export {default as Faq} from './modules/Faq';
export {default as Carousel} from './modules/Carousel';
export {default as Why} from './modules/Why';
export {default as Values} from './modules/Values';
export {default as Media} from './modules/Media';
export {default as Quotes} from './modules/Quotes';
export {default as Videos} from './modules/Videos';
export {default as Player} from './modules/Player';
export {default as Readtext} from './modules/Readtext';
export {default as Videocover} from './modules/Videocover';
export {default as Brands} from './modules/Brands';
export {default as Offers} from './modules/Offers';
export {default as Form} from './modules/Form';
export {default as Navbar} from './modules/Navbar';
export {default as Features} from './modules/Features';
export {default as Popin} from './modules/Popin';
export {default as Page} from './modules/Page';
export {default as DeviceNotice} from './modules/DeviceNotice';
